/**
 * Class Slider
 */
class Slider {

  /**
   * Constructor
   */
  constructor(){
    // Properties
    this.slider = document.getElementById("pepzine-slider");
    this.currentSlides = this.slider.getElementsByTagName('img');
    this.currentSlidesIndexes = [];
    this.firstImage = this.slider.getElementsByTagName('img')[0];
    this.imageHeight = this.firstImage.offsetHeight;
    this.imageWidth = this.firstImage.offsetWidth;
    this.pos = [];
    this.slides 
      = document.getElementById("pepzine-slider-items")
      .getElementsByTagName("img");
    this.slidesIndexes = [];

    this.init();
  }

  init() {

    console.log("init pepzine slider");
    if (this.slides.length<4) {
      console.log('not enough slides to activate the slider');
      document.getElementById("pepzine-next-slide").style.display = "none";
    }

    console.log("set slider height")
    this.slider.style.height = this.imageHeight + "px";

    for(var i=0; i<this.currentSlides.length; i++) {
      this.currentSlidesIndexes.push(i);
      this.pos.push(this.currentSlides[i].offsetLeft);
      this.currentSlides[i].style.left = this.currentSlides[i].offsetLeft + "px";
    }

    console.log("set absolute pos for currentSlides");
    console.log("set no margins for currentSlides");
    for(var i=0; i<this.currentSlides.length; i++) {
      this.currentSlides[i].style.position = "absolute";
      this.currentSlides[i].style.margin = 0;
    }

    for(var i=0; i<this.slides.length; i++) {
      this.slidesIndexes.push(i);
    }

  }

  resize(){
    console.log('resize event - reinit peps display');
    console.log('remove custom styles for currentSlides');
    console.log(this);
    for(var i=0; i<this.currentSlides.length; i++) {
      this.currentSlides[i].removeAttribute('style');
      this.currentSlides[i].style.position =  "relative";
      this.currentSlides[i].style.left = null;
    }
    console.log('set slider height');
    this.imageHeight = this.currentSlides[0].offsetHeight;
    this.slider.style.height = this.imageHeight + "px";
    console.log('save slides positions');
    this.pos = [];
    for(var i=0; i<this.currentSlides.length; i++) {
      this.pos.push(this.currentSlides[i].offsetLeft);
      this.currentSlides[i].style.left = this.currentSlides[i].offsetLeft + "px";
    }
    console.log('set absolute and updated left values');
    for(var i=0; i<this.currentSlides.length; i++) {
      this.currentSlides[i].style.position = "absolute";
      this.currentSlides[i].style.margin = 0;
    }
  }

  prev() {

    console.log('get prev slide index');
    var currentFirstSlideIndex = this.currentSlidesIndexes[0];
    var newSlideIndex
      = (this.slidesIndexes.indexOf(currentFirstSlideIndex-1) > -1)
      ? this.slidesIndexes.indexOf(currentFirstSlideIndex-1)
      : "break";

    if (newSlideIndex == "break"){
      return false;
    }

    console.log('insert prev slide');
    var newSlide = this.slides[newSlideIndex].cloneNode(true);
    this.slider.insertBefore(newSlide, this.slider.childNodes[0]);
    newSlide.style.margin = "0";
    newSlide.style.position = "absolute";
    newSlide.style.left = "-" + newSlide.offsetWidth + "px";

    console.log('sliding animation');
    var tl = new TimelineLite();
    console.log(this.currentSlides[0]);
    for(var i=this.pos.length-1; i>-1; i--){
      if (i==this.pos.length-1){
        console.log(this.currentSlides[3]);
        tl.to(this.currentSlides[3], 0.4, {
          left: this.slider.offsetWidth + "px",
          onComplete: function(){
            console.log('remove last slide');
            console.log(this);
            this.slider.removeChild(this.currentSlides[3]);
          }.bind(this)
        });
      }
      tl.to(this.currentSlides[i], 0.4, {
        left: this.pos[i]
      }, "-=0.3");
    }

    console.log('update current slides indexes');
    this.currentSlidesIndexes.pop();
    this.currentSlidesIndexes.unshift(newSlideIndex);

    console.log('show next link');
    document.getElementById("pepzine-next-slide").style.display = "block";

    console.log('hide link if no more slides');
    if (this.currentSlidesIndexes[0]
        == this.slidesIndexes[0]) {
      document.getElementById("pepzine-prev-slide").style.display = "none";
    }

  }

  next(){
    console.log('get next slide index');
    var currentLastSlideIndex = this.currentSlidesIndexes[this.currentSlides.length-1];
    var newSlideIndex
      = (this.slidesIndexes.indexOf(currentLastSlideIndex+1) > -1)
      ? this.slidesIndexes.indexOf(currentLastSlideIndex+1)
      : "break";

    if (newSlideIndex == "break"){
      return false;
    }

    console.log('insert next slide');
    var newSlide = this.slides[newSlideIndex].cloneNode(true);
    this.slider.appendChild(newSlide);
    newSlide.style.margin = "0";
    newSlide.style.position = "absolute";
    newSlide.style.left = this.slider.offsetWidth + "px";

    console.log('sliding animation');
    var tl = new TimelineLite();
    console.log(this.currentSlides[0]);

    for(var i=0; i<this.pos.length; i++){
      if (i==0){
        tl.to(this.currentSlides[0], 0.4, {
          left: "-" + newSlide.offsetWidth + "px",
          onComplete: function(){
            console.log('remove first slide');
            console.log(this);
            this.slider.removeChild(this.currentSlides[0]);
          }.bind(this)
        });
      }
      tl.to(this.currentSlides[i+1], 0.4, {
        left: this.pos[i]
      }, "-=0.3");
    }

    console.log('update current slides indexes');
    this.currentSlidesIndexes.shift();
    this.currentSlidesIndexes.push(newSlideIndex);

    console.log('show prev link');
    document.getElementById("pepzine-prev-slide").style.display = "block";

    console.log('hide link if no more slides');
    if (this.currentSlidesIndexes[this.currentSlidesIndexes.length-1]
        == this.slidesIndexes[this.slidesIndexes.length-1]) {
      document.getElementById("pepzine-next-slide").style.display = "none";
    }

  }

}

export default Slider;


